// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__loader_inside_btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: transparent;
  z-index: 1000000000;
}`, "",{"version":3,"sources":["webpack://./src/components/OffboardingBox/index.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;EACA,mBAAA;AAAJ","sourcesContent":[".__loader_inside_btn {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background-color: transparent;\n    z-index: 1000000000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
